import { Card, CardContent, Grid } from "@mui/material";

import {
  GridColDef,
  GridInitialState,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";
import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";
import { formatNumber } from "utils/formatting";

type BrandFreshness_T = {
  id: number;
  country_code: string;
  brand_count_by_country: number;
  percent_of_brand_freshness_30_days: number;
  percent_of_brand_freshness_60_days: number;
  percent_of_brand_freshness_90_days: number;
};

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [] },
  pagination: { paginationModel: { pageSize: 25, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
};

const BrandFreshness: React.FC<any> = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [brandFreshnessData, setBrandFreshnessData] = useState<
    BrandFreshness_T[]
  >([]);

  const { showError } = useError();
  const { apiRequest } = useApi();

  const fetchBrandFreshnessData = async () => {
    try {
      setLoading(true); // Set loading to true before the API request
      const response = await apiRequest<BrandFreshness_T[]>(
        `/brand_reports/insights/get_brand_freshness`,
        { method: "GET" }
      );
      if (response.data) setBrandFreshnessData(response.data);
    } catch (error) {
      console.error(error);
      showError(`Error fetching brand freshness data.`);
    } finally {
      setLoading(false); // Set loading to false after data is fetched
    }
  };

  useEffect(() => {
    fetchBrandFreshnessData();
  }, []);

  const columns_def: GridColDef[] = [
    { field: "country_code", headerName: "Country Code", width: 150 },
    {
      field: "brand_count_by_country",
      headerName: "Brand Count by Country",
      width: 200,
      renderCell: (params: GridRenderCellParams<Number>) =>
        formatNumber(params.value),
    },
    {
      field: "percent_of_brand_freshness_30_days",
      headerName: "Freshness 30 Days (%)",
      width: 200,
    },
    {
      field: "percent_of_brand_freshness_60_days",
      headerName: "Freshness 60 Days (%)",
      width: 200,
    },
    {
      field: "percent_of_brand_freshness_90_days",
      headerName: "Freshness 90 Days (%)",
      width: 200,
    },
  ];

  return (
    <Grid container spacing={2}>
      {/* Data Grid Section */}
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <GaneshDataGrid
              loading={loading}
              data={brandFreshnessData}
              columns={columns_def}
              gridId="brandFreshnessGrid"
              defaultGridState={defaultGridState}
              customHeight="400px"
              showGridSaver={false}
              getRowId={(row: BrandFreshness_T) => row.id}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default BrandFreshness;
